import { TempusDominus } from '@eonasdan/tempus-dominus'
import { DateRangeConfig } from '../tempusDominusConfig'
import datePicker from './datePicker'

export default class dateRangePicker extends datePicker {
  initializePicker () {
    this.picker = new TempusDominus(this.$element.get(0), DateRangeConfig)
  }
}
